import { trellisPalette } from "components/custom/analytics/palettes";

import type React from "react";

interface WizardUpdateButtonProps {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  readyToProceed?: boolean;
}

export const WizardUpdateButton = ({ onClick, disabled, text, readyToProceed }: WizardUpdateButtonProps) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={readyToProceed ? "proceedAnimation" : undefined}
    style={{
      transform: "none",
      boxShadow: "none",
      width: "100%",
      padding: "2rem",
      background: readyToProceed ? trellisPalette[0] : "#CCC",
      display: "flex",
      flexDirection: "column",
      border: "none",
      color: "#FFF",
      fontSize: "2rem",
      fontWeight: 600,
    }}
  >
    <small style={{ fontSize: "1.3rem", fontWeight: 500 }}>Next Step</small>
    {text || "Save"}
  </button>
);

interface WizardCancelButtonProps {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  color?: string;
  children?: React.ReactNode;
  inlineModal?: boolean;
}

export const WizardCancelButton = ({
  onClick,
  disabled,
  text,
  color,
  children,
  inlineModal = false,
}: WizardCancelButtonProps) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={{
      transform: "none",
      boxShadow: "none",
      width: "100%",
      padding: "2rem",
      background: color ?? "#ABB5BE",
      display: "flex",
      flexDirection: "column",
      border: "none",
      color: "#FFF",
      fontSize: "2rem",
      fontWeight: 600,
    }}
  >
    {children}

    {text !== "Cancel" && !children && <small style={{ fontSize: "1.3rem", fontWeight: 500 }}>Previous Step</small>}
    <span>
      {text ?
        text
      : inlineModal ?
        ""
      : "Cancel"}
    </span>
  </button>
);
